import angular from 'angular';
import customInputPercentage from './customInputPercentage';

export default angular
  .module('components.customInputPercentage', [])
  .component('customInputPercentage', customInputPercentage).name;
